<template>
  <div class="s-financialInsurance-container container">
    <topNav></topNav>
    <div class="topBg">
      <div class="banner w1300 marginAuto">
        <div class="banner-flow w900 atMiddle">
          <ul class="flow">
            <li>
              <img src="../assets/image/financialInsurance/step1.png" class="img" alt="" />
              <p class="imgTitle">在线申请</p>
            </li>
            <li>
              <img src="../assets/image/financialInsurance/toRight.png" class="rightImg" alt="" />
            </li>
            <li>
              <img src="../assets/image/financialInsurance/step2.png" class="img" alt="" />
              <p class="imgTitle">银行审核</p>
            </li>
            <li>
              <img src="../assets/image/financialInsurance/toRight.png" class="rightImg" alt="" />
            </li>
            <li>
              <img src="../assets/image/financialInsurance/step3.png" class="img" alt="" />
              <p class="imgTitle">线上核实</p>
            </li>
            <li>
              <img src="../assets/image/financialInsurance/toRight.png" class="rightImg" alt="" />
            </li>
            <li>
              <img src="../assets/image/financialInsurance/step4.png" class="img" alt="" />
              <p class="imgTitle">在线授信</p>
            </li>
            <li>
              <img src="../assets/image/financialInsurance/toRight.png" class="rightImg" alt="" />
            </li>
            <li>
              <img src="../assets/image/financialInsurance/step5.png" class="img" alt="" />
              <p class="imgTitle">极速放贷</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="tab w1300 marginAuto" >
                <el-row>
                    <el-col :span="24" class="tab-col"><span :class="tabActive == '0' ? 'active' : ''" @click="changeTab('0')">金融服务</span></el-col>
                    <el-col :span="12" class="tab-col"><span :class="tabActive == '1' ? 'active' : ''" @click="changeTab('1')">保险服务</span></el-col>
                </el-row>
            </div> -->
    </div>

    <!--金融--->
    <div class="section w1300 marginAuto" v-if="tabActive == '0' && financialList.length > 0">
      <div class="sectionList" v-for="(item, index) in financialList" :key="index" @click="goRoute('financialInsuranceApply',item.id)">
        <!-- <img :src="imgUrlIn" alt="这是银行logo图片" class="bankLogo" /> -->
        <img :src="imgURL + '/' + item.img" alt="图片" class="bankLogo" />
        <div class="content">
          <p class="title">
            <span class="titleName">{{ item.institutionName }} —— {{item.productsName}}</span>
            <el-button size="mini" class="financialApplyForBtn rl" @click.stop="goRoute('financialInsuranceApplyFor',item.id)">开始申请</el-button>
          </p>
          <el-row>
            <el-col :span="6" class="type-col"><span class="name">贷款额度：</span><span class="valRed">{{ item.quotaStart }}万~{{ item.quotaEnd }}万</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">参考利率：</span><span class="valRed">{{ item.rateStart }}%~{{ item.rateEnd }}%</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">贷款期限：</span><span class="valnormall">{{ item.termStart }}~{{ item.termEnd }}年</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">抵押贷款：</span><span class="valnormall">{{
                item.guaranteeTypeValue
              }}</span></el-col>
          </el-row>
          <h4 class="childTitle">产品简介：</h4>
          <p class="details">{{ item.introductionStr || '--'}}</p>
          <h4 class="childTitle">申请条件：</h4>
          <p class="details">{{ item.conditionsStr || '--'}}</p>
          <h4 class="childTitle">所需材料：</h4>
          <p class="details">{{ item.materialsStr || '--'}}</p>
        </div>
      </div>
      <div class="s-transaction-pagination">
        <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next" @current-change="currentChange" :total="total"></el-pagination>
      </div>
    </div>
    <div class="section w1300 marginAuto" v-if="tabActive == '0' && financialList.length == 0">
      <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
    <!--保险--->
    <div class="section w1300 marginAuto" v-if="tabActive == '1'">
      <div class="sectionList" v-for="(item, index) in insuranceList" :key="index">
        <img :src="item.image" alt="这是银行logo图片" class="bankLogo" />
        <div class="content">
          <p class="title">
            <span>{{ item.title }}</span>
            <el-button size="mini" class="financialApplyForBtn rl" @click.stop="goRoute('financialInsuranceApplyFor',item.id)">开始申请</el-button>
          </p>
          <el-row>
            <el-col :span="6" class="type-col"><span class="name">贷款额度：</span><span class="valRed">{{ item.quota }}</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">参考利率：</span><span class="valRed">{{ item.interestRate }}</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">贷款期限：</span><span class="valnormall">{{ item.deadline }}</span></el-col>
            <el-col :span="6" class="type-col"><span class="name">抵押贷款：</span><span class="valnormall">{{ item.loans }}</span></el-col>
          </el-row>
          <h4 class="childTitle">产品简介：</h4>
          <p class="details">
            重点支持粮食适度规模经营，促进粮食生产，确保粮食安全，实现粮食稳产增产。
          </p>
          <h4 class="childTitle">申请条件：</h4>
          <p class="details">坚持粮食种植为主业，粮食种植面积不少于 100亩</p>
          <h4 class="childTitle">所需材料：</h4>
          <p class="details">
            1、借款人夫妻及反担保人夫妻双方身份证、户口本、结婚证
            2、家庭房产、资产证明...
          </p>
        </div>
      </div>
    </div>
    <footerNav></footerNav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { getFinancialProductsListPage } from "../utils/api/financialInsurance";
export default {
  name: "financialInsurance",
  components: { topNav, footerNav },
  data() {
    return {
      tabActive: "0",
      financialList: [],
      insuranceList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      imgUrlIn: "",
      defaultImg: require("../assets/image/dealmakers/default.png"),
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    //金融银行列表
    this.getFinancialProductsListPage();
  },
  methods: {
    changeTab(num) {
      this.tabActive = num;
    },
    goRoute(Parmas, id) {
      this.$router.push({
        path: "financialInsuranceApplyFor",
        query: { id: id, from: Parmas },
      });
      if (id == "financialInsuranceApplyForRules") {
        this.$router.push({ path: "/financialInsuranceApplyForRules" });
      }
    },
    async getFinancialProductsListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getFinancialProductsListPage(params);
      if (res.data.code == 0) {
        this.financialList = res.data.data.records;
        this.financialList.forEach((item) => {
          if (item.img != null) {
            this.imgUrlIn = this.imgURL + "/" + item.img.split(",")[0];
          } else {
            this.imgUrlIn = this.defaultImg;
          }
        });
        this.total = res.data.data.total;
      }
    },
    currentChange(value) {
      this.currentPage = value;
      this.getFinancialProductsListPage();
    },
  },
};
</script>
<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/financialInsurance.scss";
.s-financialInsurance-container{
  .el-empty__description{
		p{
			font-size: 16px;
		}
  }
}
</style>
<style lang="scss" scoped></style>